<div class="display-flex flex-column min-h-600">
  <div class="flex-grow full-height">
    <mat-stepper class="pb-1em" [linear]="dataSetUsage?.attributes?.parameters['js'] === null">
      <mat-step [label]="'data_sources.adloop_tracking.tracking_templates.intro.title'|translate"
                [stepControl]="form.get('trackingTemplatesIntro')"
                [completed]="true">
        <div>
          <h3>{{'data_sources.adloop_tracking.tracking_templates.intro.title'|translate}}</h3>
          <p class="mb-20"
             [innerHTML]="'data_sources.adloop_tracking.tracking_templates.intro.content_html'|translate"></p>
        </div>
      </mat-step>
      <mat-step [label]="'data_sources.adloop_tracking.tracking_templates.search.title'|translate"
                [completed]="nextStepIsDone()">
        <div>
          <h3>{{'data_sources.adloop_tracking.tracking_templates.search.title'|translate}}</h3>

          <app-confluence-page [pageId]="2083356990"></app-confluence-page>
        </div>
      </mat-step>
      <mat-step [label]="'data_sources.adloop_tracking.tracking_templates.social-ads.title'|translate"
                state="checklist">
        <div>
          <h3>{{'data_sources.adloop_tracking.tracking_templates.social-ads.title'|translate}}</h3>

          <app-confluence-page [pageId]="1989181445"></app-confluence-page>
        </div>
      </mat-step>
      <mat-step [label]="'data_sources.adloop_tracking.tracking_templates.ad-servers.title'|translate"
                state="checklist">
        <div>
          <h3>{{'data_sources.adloop_tracking.tracking_templates.ad-servers.title'|translate}}</h3>

          <app-confluence-page [pageId]="1987084353"></app-confluence-page>
        </div>
      </mat-step>
      <mat-step [label]="'data_sources.adloop_tracking.tracking_templates.affiliate-networks.title'|translate"
                state="checklist">
        <div>
          <h3>{{'data_sources.adloop_tracking.tracking_templates.affiliate-networks.title'|translate}}</h3>

          <app-confluence-page [pageId]="1987280956"></app-confluence-page>
        </div>
      </mat-step>
      <mat-step [label]="'data_sources.adloop_tracking.tracking_templates.retargeting.title'|translate"
                state="checklist">
        <div>
          <h3>{{'data_sources.adloop_tracking.tracking_templates.retargeting.title'|translate}}</h3>

          <app-confluence-page [pageId]="2083717121"></app-confluence-page>
        </div>
      </mat-step>
      <mat-step [label]="'data_sources.adloop_tracking.tracking_templates.not-found.title'|translate"
                state="checklist">
        <div>
          <h3>{{'data_sources.adloop_tracking.tracking_templates.not-found.title'|translate}}</h3>
          <span [innerHtml]="'data_sources.adloop_tracking.tracking_templates.not-found.content_html'|translate"></span>
        </div>
      </mat-step>
    </mat-stepper>
  </div>
  <div class="container display-flex flex-align-center justify-content-end">
    <app-button type="button"
                icon="chevron_left"
                iconPosition="left"
                class="mr-10"
                buttonType="mat-flat-button"
                *ngIf="stepper?.selectedIndex !== 0"
                (onClick)="stepper.previous()">{{ 'button.previous' | translate }}
    </app-button>

    <app-button *ngIf="stepper?.selectedIndex !== (stepper?.steps.length-1)"
                #nextBtn
                type="button"
                icon="chevron_right"
                iconPosition="right"
                class="mr-10"
                buttonType="mat-flat-button"
                (onClick)="stepper.next()">{{
      'button.next' | translate }}
    </app-button>

    <app-button *ngIf="stepper?.selectedIndex === (stepper?.steps.length-1)"
                type="submit"
                icon="done"
                #submitBtn
                iconPosition="right"
                buttonType="mat-flat-button"
                (onClick)="submitConfiguration(submitBtn)">{{'button.save'|translate}}
    </app-button>
  </div>
</div>
